import React, { useMemo } from 'react';
import { Loader } from './Loader.js';

const Link = React.forwardRef(({ className = '', children, loading, theme = 'dark', variant = 'default', ...props }, ref) => {
    const variantStyles = useMemo(() => {
        const dark = theme === 'dark';
        const hoverStyles = {
            dark: 'hover:text-lilac-500',
            light: 'hover:text-white',
            underline: 'hover:underline',
            bgHover: 'hover:bg-lilac-50',
        };
        const styles = {
            underline: 'underline',
            noUnderline: 'no-underline',
            bgHighlight: 'bg-lilac-50',
        };
        switch (variant) {
            case 'underline':
                return dark
                    ? `${styles.underline} ${hoverStyles.dark}`
                    : `${styles.underline} ${hoverStyles.light}`;
            case 'underlineHighlight':
                return dark
                    ? `${styles.underline} ${hoverStyles.dark} underline-green-400`
                    : `${styles.underline} ${hoverStyles.light} underline-white`;
            case 'underlineHover':
                return `${styles.noUnderline} ${hoverStyles.underline}`;
            case 'bgHover':
                return `${styles.noUnderline} ${hoverStyles.bgHover}`;
            case 'bgHighlight':
                return `${styles.noUnderline} ${styles.bgHighlight}`;
            default:
                return dark
                    ? `${styles.noUnderline} ${hoverStyles.dark}`
                    : `${styles.noUnderline} ${hoverStyles.light}`;
        }
    }, [theme, variant]);
    return (React.createElement("a", { className: [
            'relative',
            'underline-offset-small',
            'cursor-pointer transition-all duration-200',
            'focus:outline-none outline-none',
            variantStyles,
            className,
        ].join(' '), ref: ref, ...(props?.href ? {} : { role: 'button' }), ...props },
        children,
        React.createElement(Loader, { visible: loading, size: "small", className: "absolute left-full ml-3" })));
});

export { Link };
//# sourceMappingURL=Link.js.map
